import React from "react";

export const Logo: React.FC = () => {
  return <img src="/icons/react-icon.svg" alt="react" width="50" height="50" />;
};
